import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {IonicSelectableComponent} from 'ionic-selectable';

import {ValidatorProvider} from '../../providers/validator/validator';
import {AlertProvider} from '../../providers/alert/alert';
import {AuthProvider} from '../../providers/auth/auth';
import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';
import {EventEmitterProvider} from '../../providers/event-emitter/event-emitter';

import {RegistrationAffiliated} from '../../models/registrationaffiliated';
import {AddressServerProvider} from '../../providers/address-server/address-server';

import {RegistrationAddress} from '../../models/registrationaddress';

/**
 * Generated class for the UpdateRegistrationAffiliatedPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-update-registration-affiliated',
  templateUrl: 'update-registration-affiliated.html',
})
export class UpdateRegistrationAffiliatedPage {

  private readonly user: any;
  public invoiceCompany: any;

  public registrationAffiliatedAccepted: boolean | null = null;
  public registrationAffiliatedAware: boolean | null = null;

  public registrationAffiliated: RegistrationAffiliated;
  public registrationAddress: RegistrationAddress;
  public cepSearched: boolean;
  public states: any[];
  public cities: any[];
  public citiesStatus: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider,
    private networkMonitorProvider: NetworkMonitorProvider,
    private eventEmitterProvider: EventEmitterProvider,
    private addressServerProvider: AddressServerProvider
  ) {
    this.registrationAffiliated = new RegistrationAffiliated();
    this.registrationAddress = new RegistrationAddress();
    this.cepSearched = false;
    this.citiesStatus = false;
    this.states = [
      {id: 'AC', name: 'Acre'},
      {id: 'AL', name: 'Alagoas'},
      {id: 'AP', name: 'Amap\u00e1'},
      {id: 'AM', name: 'Amazonas'},
      {id: 'BA', name: 'Bahia'},
      {id: 'CE', name: 'Cear\u00e1'},
      {id: 'DF', name: 'Distrito Federal'},
      {id: 'ES', name: 'Esp\u00edrito Santo'},
      {id: 'GO', name: 'Goi\u00e1s'},
      {id: 'MA', name: 'Maranh\u00e3o'},
      {id: 'MT', name: 'Mato Grosso'},
      {id: 'MS', name: 'Mato Grosso do Sul'},
      {id: 'MG', name: 'Minas Gerais'},
      {id: 'PA', name: 'Par\u00e1'},
      {id: 'PB', name: 'Para\u00edba'},
      {id: 'PR', name: 'Paran\u00e1'},
      {id: 'PE', name: 'Pernambuco'},
      {id: 'PI', name: 'Piau\u00ed'},
      {id: 'RN', name: 'Rio Grande do Norte'},
      {id: 'RS', name: 'Rio Grande do Sul'},
      {id: 'RJ', name: 'Rio de Janeiro'},
      {id: 'RO', name: 'Rond\u00f4nia'},
      {id: 'RR', name: 'Roraima'},
      {id: 'SC', name: 'Santa Catarina'},
      {id: 'SP', name: 'S\u00e3o Paulo'},
      {id: 'SE', name: 'Sergipe'},
      {id: 'TO', name: 'Tocantins'}
    ];
    this.user = this.authProvider.getUser();

    if (!this.user) {
      return;
    }

    this.registrationAffiliated.federalCode = this.user.affiliatedFederalCode;
    this.registrationAffiliated.name = this.user.affiliatedName;
    this.registrationAffiliated.courseCode = this.user.courseCode;
    this.registrationAffiliated.invoiceCompany = this.user.invoiceCompany;

    this.registrationAddress.address = this.user.addressInvoice;
    this.registrationAddress.addressNumber = this.user.addressNumberInvoice;
    this.registrationAddress.addressComplement = this.user.addressComplementInvoice;
    this.registrationAddress.addressCountry = this.user.addressCountryInvoice;
    this.registrationAddress.addressCity = this.user.addressCityInvoice;
    this.registrationAddress.addressState = this.user.addressStateInvoice;
    this.registrationAddress.addressZip = this.user.addressZipInvoice;
    this.registrationAddress.addressIBGE = this.user.addressIBGEInvoice;

    this.registrationAffiliatedAccepted = this.user.affiliatedAccepted;
    this.registrationAffiliatedAware = this.user.affiliatedAware !== null;

    this.cepSearched =
      !this.validatorProvider.isEmpty(this.user.addressStateInvoice) ||
      !this.validatorProvider.isEmpty(this.user.addressCityInvoice);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UpdateRegistrationAffiliatedPage');
  }

  onBack() {
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  public doSearchZipcode(): void {
    const zip = this.registrationAddress.addressZip;

    if (this.validatorProvider.isEmpty(zip)) {
      this.alertProvider.doAlert('Forneça um CEP.', 'Atenção');
      return;
    }

    if (!this.validatorProvider.isZipcode(zip)) {
      this.alertProvider.doAlert('Forneça um CEP válido.', 'Atenção');
      return;
    }

    this.cepSearched = false;

    const loader = this.loadingCtrl.create({content: 'Pesquisando o CEP...'});
    loader.present();

    const sanitizedZip = zip.replace(/\D/g, '');

    this.addressServerProvider.searchByZip(sanitizedZip).subscribe(
      ({response}: any): void => {
        console.log(response);
        loader.dismiss();

        if (response) {
          Object.assign(this.registrationAddress, {
            address: response.address,
            addressNumber: null,
            addressComplement: response.complement,
            addressCountry: response.country,
            addressCity: response.city,
            addressState: response.state,
            addressIBGE: response.ibge,
          });
          this.cepSearched = true;
        } else {
          this.alertProvider.doConfirm(
            `O endereço não foi encontrado com o CEP ${zip}. Deseja tentar novamente?`,
            () => { /* cancelar */
            },
            () => {
              this.cepSearched = true;
            }
          );
        }
      },
      (error: any): void => {
        console.error(error);
        this.cepSearched = true;
        loader.dismiss();
        this.alertProvider.doAlert('Não foi possível pesquisar o CEP.', 'Atenção');
      }
    );
  }

  public onStateChange(event: { component: IonicSelectableComponent; value: any }): void {
    this.cities = [];
    this.citiesStatus = false;

    if (!event.value) {
      return;
    }

    const loader = this.loadingCtrl.create({
      content: `Buscando as cidades do ${event.value.name}...`,
    });
    loader.present();

    this.addressServerProvider.fetchCities(event.value.id).subscribe(
      (data: any[]): void => {
        this.cities = data.map(item => ({
          id: item.id,
          name: item.nome
        }));

        this.citiesStatus = true;
        loader.dismiss();
      },
      (): void => {
        loader.dismiss();
      }
    );
  }

  public onCityChange({value}: { component: IonicSelectableComponent; value: any }): void {
    if (!value) {
      return;
    }

    console.log('Cidade selecionada:', value);

    // Aqui você pode salvar a cidade selecionada no modelo, se necessário
    // this.registrationAddress.addressCity = value.name || value;
  }

  // public doSave(): void {
  //   if (this.registrationAffiliatedAccepted === null) {
  //     return;
  //   }
  //
  //   if (this.registrationAffiliatedAccepted === false) {
  //     console.log(registrationAffiliatedAware);
  //
  //     if (this.registrationAffiliatedAware) {
  //       this.alertProvider.doConfirm('Confirma que somente poderá realizar a prova de forma supervisionada?', (): void => {
  //         let loader = this.loadingCtrl.create({
  //           content: 'Enviando pedido...'
  //         });
  //         loader.present();
  //
  //         this.authProvider.optForNoAffiliated().subscribe((response: any): void => {
  //           loader.dismiss();
  //
  //           if (!(response && response.updated)) {
  //             this.alertProvider.doAlert('Houve problemas ao tentar optar por não ter vínculo com uma empresa. Tente novamente mais tarde.', 'Atenção');
  //             return;
  //           }
  //
  //           // Update local user data
  //           this.user.affiliatedFederalCode = this.registrationAffiliated.federalCode;
  //           this.user.affiliatedName = this.registrationAffiliated.name;
  //
  //           this.authProvider.setUser(this.user);
  //           this.eventEmitterProvider.get('registration_updated').emit(this.user);
  //         }, (error: any): void => {
  //           console.log(error);
  //           loader.dismiss();
  //           this.alertProvider.doAlert('Houve problemas ao tentar optar por não ter vínculo com uma empresa. Tente novamente mais tarde.', 'Atenção');
  //         });
  //       });
  //     }
  //
  //     return;
  //   }
  //
  //   if (this.validatorProvider.isEmpty(this.registrationAffiliated.federalCode)) {
  //     this.alertProvider.doAlert('Forneça o CNPJ da Empresa.', 'Atenção');
  //     return;
  //   }
  //
  //   if (!this.validatorProvider.isCnpj(this.registrationAffiliated.federalCode)) {
  //     this.alertProvider.doAlert('Forneça um CNPJ válido.', 'Atenção');
  //     return;
  //   }
  //
  //   if (this.validatorProvider.isEmpty(this.registrationAddress.address)) {
  //     this.alertProvider.doAlert('Forneça o endereço.', 'Atenção');
  //     return;
  //   }
  //
  //   if (this.validatorProvider.isEmpty(this.registrationAddress.addressNumber)) {
  //     this.alertProvider.doAlert('Forneça o número.', 'Atenção');
  //     return;
  //   }
  //
  //   if (this.validatorProvider.isEmpty(this.registrationAddress.addressCountry)) {
  //     this.alertProvider.doAlert('Forneça o bairro.', 'Atenção');
  //     return;
  //   }
  //
  //   this.alertProvider.doConfirm('Deseja salvar os dados da empresa?', (): void => {
  //     let loader = this.loadingCtrl.create({
  //       content: 'Enviando pedido...'
  //     });
  //     loader.present();
  //
  //     this.authProvider.updateAffiliated(this.registrationAffiliated).subscribe((response: any): void => {
  //       loader.dismiss();
  //
  //       if (!(response && response.updated)) {
  //         this.alertProvider.doAlert('Houve problemas ao tentar salvar a empresa. Tente novamente mais tarde.', 'Atenção');
  //         return;
  //       }
  //
  //       // Update local user data
  //       this.user.affiliatedFederalCode = this.registrationAffiliated.federalCode;
  //       this.user.affiliatedName = this.registrationAffiliated.name;
  //       // this.user.courseCode = this.registrationAffiliated.courseCode;
  //
  //       this.authProvider.setUser(this.user);
  //       this.eventEmitterProvider.get('registration_updated').emit(this.user);
  //
  //       this.authProvider.updateAddressInvoice(this.registrationAddress).subscribe((response: any): void => {
  //         if (!(response && response.updated)) {
  //           this.alertProvider.doAlert('Houve problemas ao tentar salvar seu endereço. Tente novamente mais tarde.', 'Atenção');
  //           return;
  //         }
  //
  //         this.alertProvider.doAlert('Os dados da empresa foram salvos com sucesso.', 'Informação');
  //
  //         // Update local user data
  //         this.user.invoiceCompany = this.registrationAffiliated.invoiceCompany;
  //         this.user.addressInvoice = this.registrationAddress.address;
  //         this.user.addressNumberInvoice = this.registrationAddress.addressNumber;
  //         this.user.addressComplementInvoice = this.registrationAddress.addressComplement;
  //         this.user.addressCountryInvoice = this.registrationAddress.addressCountry;
  //         this.user.addressCityInvoice = this.registrationAddress.addressCity;
  //         this.user.addressStateInvoice = this.registrationAddress.addressState;
  //         this.user.addressZipInvoice = this.registrationAddress.addressZip;
  //         this.user.addressIBGEInvoice = this.registrationAddress.addressIBGE;
  //
  //         this.authProvider.setUser(this.user);
  //         this.eventEmitterProvider.get('registration_updated').emit(this.user);
  //
  //         this.onBack();
  //       }, (error: any): void => {
  //         console.log(error);
  //         this.alertProvider.doAlert('Houve problemas ao tentar salvar seu endereço. Tente novamente mais tarde.', 'Atenção');
  //       });
  //     }, (error: any): void => {
  //       console.log(error);
  //       loader.dismiss();
  //       this.alertProvider.doAlert('Houve problemas ao tentar salvar a empresa. Tente novamente mais tarde.', 'Atenção');
  //     });
  //   });
  // }

  public doSave(): void {
    if (this.registrationAffiliatedAccepted === null) {
      return;
    }

    if (this.registrationAffiliatedAccepted === false) {
      return this.handleNoAffiliated();
    }

    if (!this.validateCompanyData()) {
      return;
    }

    this.alertProvider.doConfirm(
      'Deseja salvar os dados da empresa?',
      () => this.saveAffiliated()
    );
  }

  private handleNoAffiliated(): void {
    if (!this.registrationAffiliatedAware) {
      return;
    }

    this.alertProvider.doConfirm(
      'Confirma que somente poderá realizar a prova de forma supervisionada?',
      () => {
        const loader = this.loadingCtrl.create({content: 'Enviando pedido...'});
        loader.present();

        this.authProvider.optForNotAffiliate().subscribe(
          (response: any) => {
            loader.dismiss();

            if (!response || !response.updated) {
              this.alertProvider.doAlert(
                'Houve problemas ao tentar optar por não ter vínculo com uma empresa. Tente novamente mais tarde.',
                'Atenção'
              );
              return;
            }

            this.user.affiliatedAccepted = this.registrationAffiliatedAccepted;
            this.user.affiliatedAware = new Date();
            this.eventEmitterProvider.get('registration_updated').emit(this.user);
          },
          (error: any) => {
            console.error(error);
            loader.dismiss();
            this.alertProvider.doAlert(
              'Houve problemas ao tentar optar por não ter vínculo com uma empresa. Tente novamente mais tarde.',
              'Atenção'
            );
          }
        );
      }
    );
  }

  private validateCompanyData(): boolean {
    const {federalCode} = this.registrationAffiliated;
    const {address, addressNumber, addressCountry} = this.registrationAddress;

    if (this.validatorProvider.isEmpty(federalCode)) {
      this.alertProvider.doAlert('Forneça o CNPJ da Empresa.', 'Atenção');
      return false;
    }

    if (!this.validatorProvider.isCnpj(federalCode)) {
      this.alertProvider.doAlert('Forneça um CNPJ válido.', 'Atenção');
      return false;
    }

    if (this.validatorProvider.isEmpty(address)) {
      this.alertProvider.doAlert('Forneça o endereço.', 'Atenção');
      return false;
    }

    if (this.validatorProvider.isEmpty(addressNumber)) {
      this.alertProvider.doAlert('Forneça o número.', 'Atenção');
      return false;
    }

    if (this.validatorProvider.isEmpty(addressCountry)) {
      this.alertProvider.doAlert('Forneça o bairro.', 'Atenção');
      return false;
    }

    return true;
  }

  private saveAffiliated(): void {
    const loader = this.loadingCtrl.create({content: 'Enviando pedido...'});
    loader.present();

    this.authProvider.updateAffiliated(this.registrationAffiliated).subscribe(
      (response: any) => {
        loader.dismiss();

        if (!(response && response.updated)) {
          this.alertProvider.doAlert(
            'Houve problemas ao tentar salvar a empresa. Tente novamente mais tarde.',
            'Atenção'
          );
          return;
        }

        this.updateUserAffiliated();

        this.saveAddress();
      },
      (error: any) => {
        console.error(error);
        loader.dismiss();
        this.alertProvider.doAlert(
          'Houve problemas ao tentar salvar a empresa. Tente novamente mais tarde.',
          'Atenção'
        );
      }
    );
  }

  private saveAddress(): void {
    this.authProvider.updateAddressInvoice(this.registrationAddress).subscribe(
      (response: any) => {
        if (!(response && response.updated)) {
          this.alertProvider.doAlert(
            'Houve problemas ao tentar salvar seu endereço. Tente novamente mais tarde.',
            'Atenção'
          );
          return;
        }

        this.updateUserAddress();

        this.alertProvider.doAlert('Os dados da empresa foram salvos com sucesso.', 'Informação');

        this.onBack();
      },
      (error: any) => {
        console.error(error);
        this.alertProvider.doAlert(
          'Houve problemas ao tentar salvar seu endereço. Tente novamente mais tarde.',
          'Atenção'
        );
      }
    );
  }

  private updateUserAffiliated(): void {
    this.user.affiliatedFederalCode = this.registrationAffiliated.federalCode;
    this.user.affiliatedName = this.registrationAffiliated.name;

    this.authProvider.setUser(this.user);
    this.eventEmitterProvider.get('registration_updated').emit(this.user);
  }

  private updateUserAddress(): void {
    Object.assign(this.user, {
      invoiceCompany: this.registrationAffiliated.invoiceCompany,
      addressInvoice: this.registrationAddress.address,
      addressNumberInvoice: this.registrationAddress.addressNumber,
      addressComplementInvoice: this.registrationAddress.addressComplement,
      addressCountryInvoice: this.registrationAddress.addressCountry,
      addressCityInvoice: this.registrationAddress.addressCity,
      addressStateInvoice: this.registrationAddress.addressState,
      addressZipInvoice: this.registrationAddress.addressZip,
      addressIBGEInvoice: this.registrationAddress.addressIBGE,
    });

    this.authProvider.setUser(this.user);
    this.eventEmitterProvider.get('registration_updated').emit(this.user);
  }

}



// WEBPACK FOOTER //
// ./src/pages/update-registration-affiliated/update-registration-affiliated.ts